import { CURRENCY_ACTION_TYPE } from "./currency.action";

export const CURRENCY_MESSAGE_CONTEXT = {
	getAll: CURRENCY_ACTION_TYPE.getAll,
};
